function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TreeViewContext } from '../../context/TreeViewProvider';
import { Checkbox } from '@dtsl/react/dist/components/Checkbox';
import { HelpButton } from '@dtsl/react/dist/components/HelpButton';
function CheckboxItem(props) {
  const {
    treeNode = {},
    onChange = () => {},
    disabled = false
  } = props;
  const {
    id = '',
    value = '',
    helpButtonMetaData
  } = treeNode;
  const {
    checked: checkedList,
    indeterminate,
    getChecked,
    getUnChecked
  } = useContext(TreeViewContext);
  const isUndetermined = indeterminate.has(id);
  const checkBoxVariant = isUndetermined ? 'undetermined' : 'positive';
  const isChecked = checkedList.has(id);
  function handleCheckboxClick(e) {
    let selectedData = {};
    if (e.target.checked) {
      // checking its not an uncheck action
      selectedData = getChecked(treeNode);
    } else {
      selectedData = getUnChecked(treeNode);
    }
    const {
      newChecked,
      newIndeterminate
    } = selectedData;
    // return list of checked and indeterminate checkbox ids
    // as array arguments to the custom handler for end dev to make use of
    onChange(e, [...newChecked], [...newIndeterminate]);
  }
  useEffect(() => {
    getChecked(treeNode);
    getUnChecked(treeNode);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    variant: checkBoxVariant,
    identifier: `checkbox-${id}`,
    "data-testid": id,
    tabIndex: disabled ? -1 : 0,
    label: value,
    checked: isChecked || isUndetermined // checked state of checkbox.
    ,
    name: value,
    value: value,
    onChange: handleCheckboxClick // onChange handler of checkbox
  }), helpButtonMetaData && /*#__PURE__*/React.createElement(HelpButton, _extends({
    dataTestId: `help-button-${id}`
  }, helpButtonMetaData)));
}
CheckboxItem.propTypes = {
  treeNode: PropTypes.oneOfType([PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string,
    helpButtonMetaData: PropTypes.object,
    children: PropTypes.array
  }), PropTypes.node]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
export default CheckboxItem;